// usage: Date().addDays(nrOfDays)
// will add a number of days to the date

Date.prototype.addDays = function (days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}